// extracted by mini-css-extract-plugin
export var types = "Type-module--types--39749";